import styled, {css} from "styled-components";

export const PicksContainer = styled.div`
  display: flex;
  flex-direction: column;
  flex:1
`;

export const PicksHeader = styled.div`
    display:flex;
    padding-bottom: 20px;
    border-bottom: 1px solid #E9EBEF;
    .tit{
        margin-right: 5px;
        color: #000;
        font-family: 'Saira Semi Condensed', sans-serif;
        font-size: 20px;
        font-style: normal;
        font-weight: 600;
        line-height: normal;
    }
    .positions{
        display: flex;
        gap: 10px;
        align-items: center;
        flex-wrap: wrap;
    }
`;
export const NumItem = styled.div`
	min-width: 45px;
	height: 32px;
	border: 1px solid #989ea4;
	border-radius: 4px;
	display: flex;
	align-items: center;
	justify-content: center;
	padding: 5px 10px;
	${props =>
    props.backColor &&
    css`
			background-color: ${props => props.backColor};
			border: none;
		`}
	span {
		color: #0e1118;
		font-size: 18px;
		font-family: 'Saira Semi Condensed', sans-serif;
		font-weight: 400;
	}
`;

export const PicksTable = styled.table`
  width: 100%;
  border-collapse: collapse;
    
  th {
      border-bottom: 1px solid #E9EBEF;
      text-align: left;
      color: #000;
      font-family: 'Saira Semi Condensed', sans-serif;
      font-size: 16px;
      font-style: normal;
      font-weight: 600;
      line-height: normal;
      padding: 10px;
  }
  td {
      text-align: left;
      padding: 10px;
      color: #000;
      font-family: 'Saira Semi Condensed', sans-serif;
      font-size: 16px;
      font-style: normal;
      font-weight: 400;
      line-height: normal;
      border-bottom: 1px solid #E9EBEF;
  }
`;

export const Button = styled.button`
    padding: 6px 24px;
    border-radius: 3px;
    background: #004ea3;
    color: #fff;
    font-family: 'Saira Semi Condensed', sans-serif;
    font-size: 19px;
    font-style: normal;
    font-weight: 500;
    line-height: 24px;
    cursor: pointer;
`;

export const RemoveButton = styled.button`
  padding: 6px 24px;
  border-radius: 3px;
  background: #c72b2b;
  color: #fff;
  font-family: 'Saira Semi Condensed', sans-serif;
  font-size: 19px;
  font-style: normal;
  font-weight: 500;
  line-height: 24px;
  cursor: pointer;
  border: none;
`;







